import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useLang } from "../i18n";
import { Skull, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (err) { setError(apiError(err.response?.data?.detail) || err.message); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex items-center gap-2 mb-8"><Skull className="text-primary" size={28} /><span className="heading text-2xl font-bold text-white">MetalVault</span></div>
        <h2 className="heading text-3xl font-bold text-white mb-6">{t("reset_password")}</h2>
        {error && <div className="mb-4 text-sm text-red-400">{error}</div>}
        {!submitted ? (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-caps text-xs text-zinc-400">{t("email")}</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full bg-black border border-zinc-800 rounded-sm px-3 py-2.5 text-white focus:border-primary focus:outline-none" />
            </div>
            <button data-testid="forgot-submit" type="submit" className="w-full bg-primary text-primary-foreground label-caps py-3 rounded-sm font-semibold hover:bg-yellow-400">{t("send_reset_link")}</button>
          </form>
        ) : (
          <div data-testid="forgot-confirmation" className="space-y-3 border border-zinc-800 rounded-sm p-5 bg-black">
            <MailCheck className="text-primary" size={28} />
            <p className="text-sm text-zinc-200">
              Si un compte est associé à cette adresse, un email de réinitialisation vient d'être envoyé.
            </p>
            <p className="text-xs text-zinc-500">
              If an account exists for this address, a reset email has been sent. Vérifiez vos spams. Le lien expire dans 1 heure.
            </p>
          </div>
        )}
        <p className="mt-6 text-sm text-zinc-400"><Link to="/login" className="text-primary hover:underline">{t("back_to_login")}</Link></p>
      </div>
    </div>
  );
}
